export default __webpack_public_path__ + "static/media/IMG_8288.934272dd.jpg";